jQuery(document).ready(function($){

    $('.content8__logos--slider').slick({
        dots: false,
        speed: 300,
        infinite: true,
        autoplay: true,
        fade: false,
        slidesToShow: 4,
        slidesToScroll: 4,
        autoplaySpeed: 5000,
        cssEase: 'ease-out',
        arrows: true,
        appendArrows: '.content8__item__arrows',
        prevArrow: '<button type="button" class="slick-prev"><i class="icon-chevron-left"></i></button>',
        nextArrow: '<button type="button" class="slick-next"><i class="icon-chevron-right"></i></button>',
    });

});
